"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTabActiveStyles = exports.GetBadgeHoverStyles = exports.GetLabelHoverStyles = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = require("styled-components");
const styles_1 = require("./styles");
const GetLabelHoverStyles = (inverted) => {
    return (0, styled_components_1.css) `
    ${styles_1.StyledTabLabel} {
      color: ${!inverted ? theme_1.primary.dark : (0, utils_1.hexToRgba)(theme_1.grayScale[50], 0.8)};
    }
  `;
};
exports.GetLabelHoverStyles = GetLabelHoverStyles;
const GetBadgeHoverStyles = (inverted) => {
    return (0, styled_components_1.css) `
    ${styles_1.StyledTabNumber} {
      color: ${inverted ? theme_1.primary.dark : theme_1.grayScale[50]};
      background-color: ${inverted ? (0, utils_1.hexToRgba)(theme_1.grayScale[50], 0.8) : theme_1.primary.dark};
    }
  `;
};
exports.GetBadgeHoverStyles = GetBadgeHoverStyles;
const GetTabActiveStyles = ({ inverted = false, activeTab, currentElement, }) => {
    if (activeTab === currentElement) {
        const commonColors = !inverted ? theme_1.primary.light : theme_1.grayScale[50];
        return (0, styled_components_1.css) `
      ${styles_1.StyledTabLabel} {
        color: ${commonColors};
      }
      ${styles_1.StyledTabNumber} {
        background-color: ${commonColors};
        color: ${inverted ? theme_1.primary.dark : theme_1.grayScale[50]};
      }
      ${styles_1.StyledTabItem} {
        &::after {
          width: calc(100% - 4px);
        }
      }
    `;
    }
};
exports.GetTabActiveStyles = GetTabActiveStyles;
//# sourceMappingURL=utils.js.map